import { Component, computed, input, output } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { AutocompleteComponent } from '@valk-nx/components/ui-autocomplete/src/lib/autocomplete';
import type { DropdownOption } from '@valk-nx/components/ui-select-shell/src/lib/select-shell.interface';
import { MINIMUM_QUERY_LENGTH } from '@valk-nx/services/location-search/src/lib/location-search.service';

@Component({
	selector: `vp-filter-search`,
	templateUrl: './filter-search.html',
	imports: [TranslatePipe, AutocompleteComponent],
})
export class FilterSearchComponent {
	protected readonly minimumCharacters = MINIMUM_QUERY_LENGTH;

	options = input.required<DropdownOption[]>();
	loading = input<boolean>(false);
	selectedLabel = input<string | null>(null);

	searched = output<string>();
	selected = output<string>();

	// The label doubles as the value: it only marks the input as filled, the
	// place itself is identified by the coordinates the parent holds
	protected readonly selectedOption = computed<DropdownOption | null>(() => {
		const label = this.selectedLabel();
		return label ? { label, value: label } : null;
	});

	onSearched(term: string): void {
		this.searched.emit(term);
	}

	onSelected(value: string): void {
		this.selected.emit(value);
	}
}
